import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';

import { Form } from '../../shared/form';
import { HttpErrorHandler } from '../../shared/http-error-handler';

import { SaleOfferService } from '../../_services/commercialization.service';
import { SaleOffer } from 'app/_models/commercialization';

@Component({
  selector: 'app-sale-offer-form',
  templateUrl: './sale-offer-form.component.html',
})
export class SaleOfferFormComponent extends Form implements OnInit {
  // Component attributes
  form: FormGroup;
  saleOffer: SaleOffer;
  loading: boolean;
  otherInterestedClients: any[] = [];
  constructor(
    private fb: FormBuilder,
    private saleOfferService: SaleOfferService,
    protected route: ActivatedRoute,
    protected router: Router,
    private location: Location,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(route, httpErrorHandler);
    this.loading = true;
    this.form = fb.group({
      id: null,
      kg: null,
      price_kg: null,
      offer_end_datetime: null,
    });
    this.saleOffer = new SaleOffer();
  }

  ngOnInit() {
    if (this.location.path() === '/sale-offers/add') {
      this.saleOffer = new SaleOffer();
      this.setFormMode('create');
      this.loading = false;
    } else {
      this.getSaleOffer();
      this.setFormMode('update');
    }
  }

  handleError(error) {
    const errors = this.httpErrorHandler.handleHttpError(error);
    this.parseApiErrors(errors, this.form);
  }

  onSubmit() {
    if (this.createMode) {
      this.createSaleOffer();
    } else {
      this.updateSaleOffer();
    }
  }

  createSaleOffer() {
    this.saleOfferService.create(this.saleOffer).subscribe(
      (saleOffer) => this.onCreate(saleOffer),
      (error) => this.handleError(error)
    );
  }

  updateSaleOffer() {
    this.saleOfferService.update(this.saleOffer).subscribe(
      (saleOffer) => this.onUpdate(saleOffer),
      (error) => this.handleError(error)
    );
  }

  onCreate(saleOffer) {
    this.goBack();
  }

  onUpdate(saleOffer) {
    this.goBack();
  }

  goBack(): void {
    this.location.back();
  }
  getSaleOffer() {
    this.route.params.forEach((params: Params) => {
      const id = +params['id'];
      this.saleOfferService.getSaleOffer(id).subscribe(
        (saleOffer) => {
          this.saleOffer = saleOffer;
          if (this.saleOffer.offer_end_datetime) {
            this.saleOffer.offer_end_datetime = this.toDateTimeLocalInputValue(this.saleOffer.offer_end_datetime);
          }
          if (saleOffer.client_messages) {
            this.otherInterestedClients = saleOffer.client_messages.filter(function (el) {
              if (el.client.id !== saleOffer.buyer.client.id && el.purchase_tried_date) {
                return el;
              }
            });
          }
          this.loading = false;
        },
        (error) => this.handleError(error)
      );
    });
  }
  toDateTimeLocalInputValue(dateValue: string): string {
    if (dateValue) {
      const date = new Date(dateValue);
      const offset = date.getTimezoneOffset();
      const localDate = new Date(date.getTime() - offset * 60000);

      return localDate.toISOString().slice(0, 16);
    } else {
      return dateValue;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sale-offers/sale-offer-form/sale-offer-form.component.ts